import React, { Component, Fragment } from "react";
import { Formik, Form } from "formik";
import { object, string, number, array } from "yup";
import {
  Button,
  Header,
  Modal,
  Dropdown,
  Divider,
  Grid,
  Loader,
  Dimmer,
  Input,
  Icon,
  Label,
  Checkbox,
  Menu,
  Select
} from "semantic-ui-react";
import { connect } from "react-redux";
import build from "redux-object";
import { isEmpty, get, range } from "lodash";
import download from "downloadjs";
import { DateInput } from "semantic-ui-calendar-react";
import "./TenantModal.css";

import { appLoaded } from "../../actions/common.actions";
import AppButton from "../Common/AppButton";
import { fetchVats } from "../../actions/vats.actions";
import {
  createTenant,
  updateTenant,
  exportCustomersReport,
  fetchCurrency,
  fetchTenantCurrencies
} from "../../actions/tenants.actions";
import {
  fetchProductOptions,
  fetchFilteredProductBundles,
  fetchFilteredProductLicenseBundles
} from "../../actions/products.actions";
import config from "../../config";
import { isDateFormatValid, DATE_FORMAT_DATE_INPUT } from "../../services/date-helper.service";
import { INVOICE_SERVICES } from "../Invoices/constants";
import NotificationService from "../../services/notification.service";

const BOOLEAN_OPTIONS = [
  { text: "Yes", value: true },
  { text: "No", value: false }
];

const BOOLEAN_SETTINGS = {
  autoApprove: "Auto-approve invoices",
  autoClose: "Automatically close zero amount invoices",
  forceRecurring: "Force Recurring",
  postPaymentsActive: "Enable post payments",
  skipFailedPayments: "Invoices are not blocked if payment failed or pending",
  upDelivery: "UPDelivery",
  alignDates: "Enable renewal dates alignment"
};

const NETSUITE_BOOLEAN_SETTINGS = {
  customersReportToBeEmailed: "To be emailed",
  skipFinanceApproval: "Skip Finance Approval",
  skipSbdmApproval: "Skip SBDM Approval"
};

const NETSUITE_NON_BOOLEAN_SETTINGS = {
  customersReportSubsidiary: "Subsidiary",
  customerInvoicesPrefix: "Customer/invoices prefix",
  customersReportLegacyEntity: "Legacy entity",
  customersReportTerms: "Terms",
  customersReportSbdm: "SBDM",
  customersReportInvoicingEmail: "Invoicing email",
  customersReportTaxCode: "Tax code for tenant country",
  customersReportEuTaxCode: "Tax code for other EU countries",
  customersReportNonEuTaxCode: "Tax code for non EU countries"
};
export class TenantModal extends Component {
  state = {
    emailNotificationValidAPEnabled: false,
    emailNotificationInvalidAPEnabled: false,
    withNetsuiteApi: false,
    tenantCurrencies: [],
    anotherCurrency: [],
    invoiceAmountCurrency: [],
    newInvoiceCurrencies: [],
    filteredInvoiceAmountCurrency: [],
    minimAnotherCurrency: [],
    separateInvoiceCurrenciesNull: [],
    separateInvoiceCurrenciesNotNull: [],
    label: false
  };

  static getDerivedStateFromProps(nextProps, state) {
    const { products, productBundles, productLicenseBundles, currentTenant, tenantCurrencies } = nextProps;
    const nextState = {};

    if (state.init) {
      nextState.bundleOptions = null;
      nextState.licenseBundleOptions = null;
      nextState.productOptions = null;
      nextState.init = false;
    }

    if (
      (isEmpty(state.bundleOptions) && productBundles !== null) ||
      (productBundles !== null && get(state, "bundleOptions[0].key") !== get(productBundles, "[0].bundle.id"))
    ) {
      nextState.bundleOptions = productBundles.map(({ bundle }) => ({
        key: bundle.id,
        text: bundle.name + ` (${bundle.id})`,
        value: bundle.id
      }));
    }

    // if (
    //   (isEmpty(state.licenseBundleOptions) && productLicenseBundles !== null) ||
    //   (productLicenseBundles !== null &&
    //     get(state, "licenseBundleOptions[0].key") !== get(productLicenseBundles, "[0].licenseBundle.id"))
    // ) {
    //   nextState.licenseBundleOptions = productLicenseBundles.map(({ bundle }) => ({
    //     key: bundle.id,
    //     text: bundle.name + ` (${bundle.id})`,
    //     value: bundle.id
    //   }));
    // }

    if (
      (isEmpty(state.productOptions) && !isEmpty(products)) ||
      (!isEmpty(products) && get(state, "productOptions[0].key") !== get(products, "[0].id"))
    ) {
      nextState.productOptions = products.map(product => ({
        key: product.id,
        text: product.name,
        value: product.id
      }));
    }
    return { ...state, ...nextState };
  }

  fetchFilteredProductBundles = productSlug => {
    this.props.dispatch(
      fetchFilteredProductBundles({
        filter: { productSlug: productSlug },
        include: "bundle"
      })
    );
  };

  fetchFilteredProductLicenseBundles = productSlug => {
    this.props.dispatch(
      fetchFilteredProductLicenseBundles({
        filter: { productSlug: productSlug },
        include: "license_bundle"
      })
    );
  };

  handleOpen = () => {
    const { vats, site_settings, tenantCurrencies, currentTenant, dispatch, products } = this.props;
    if (!site_settings) {
      dispatch(fetchCurrency());
    }
    if (!tenantCurrencies || !vats) {
      dispatch(fetchTenantCurrencies()).then(() => {
        let another = this.props.tenantCurrencies?.map(item => {
          return { key: item.id, value: item.currency, text: item.currency };
        });
        this.setState({ newInvoiceCurrencies: this.props.tenantCurrencies });
        this.setState({ invoiceAmountCurrency: this.props.tenantCurrencies });
        this.setState({ anotherCurrency: another });
        this.setState({ minimAnotherCurrency: another });
        this.separateInvoiceAmountCurrencyNull(this.props.tenantCurrencies);
      });
    }

    if (!vats) {
      dispatch(fetchVats());
    }
    if (!products) {
      dispatch(fetchProductOptions());
    }

    this.setState({
      modalOpen: true,
      init: true,
      exportCustomersReportFor: "all",
      withPeriod: false,
      withNetSuiteFields: false,
      automaticNetsuiteApiImport: get(currentTenant, "automaticNetsuiteApiImport", false),
      withNetsuiteApi: get(currentTenant, "netsuiteApiImport", false),
      emailNotificationValidAPEnabled: get(currentTenant, "notifyDayValidApCustomers", "") !== "none",
      emailNotificationInvalidAPEnabled: get(currentTenant, "notifyDayInvalidApCustomers", "") !== "none",
      couponsEnabled: get(currentTenant, "couponsEnabled", "") !== "none",
      isFlag: false
    });
  };

  handleCancel = () => this.setState({ filteredInvoiceAmountCurrency: [], modalOpen: false, label: false });

  tenantCreation = data => {
    const { vatCountryCode, vatPercentage, customersReportPortalName, ...newData } = data;
    this.props.dispatch(createTenant(newData, vatCountryCode));
  };

  tenantUpdate = data => {
    this.checkModificationInvoiceCurrencies();
    const { tenantCurrencies, anotherCurrencyState, filteredInvoiceAmountCurrency } = this.state;
    const { vatCountryCode, vatPercentage, customersReportPortalName, ...newData } = data;
    this.props.dispatch(
      updateTenant(newData, vatCountryCode, tenantCurrencies, anotherCurrencyState, filteredInvoiceAmountCurrency)
    );
  };

  generateCustomersReport = async invoiceType => {
    const { exportCustomersReportFor, sinceDate, untilDate, withPeriod } = this.state;
    let dateBetween = {};
    if (withPeriod) dateBetween = { sinceDate, untilDate };
    await this.props.dispatch(exportCustomersReport(exportCustomersReportFor || "all", dateBetween, invoiceType));
    this.downloadCustomersReport(exportCustomersReportFor);
  };

  downloadCustomersReport = exportCustomersReportFor => {
    const { customersReport } = this.props;
    const decodedCustomersReport = atob(customersReport);
    if (!isEmpty(this.props.errors)) return;
    download(decodedCustomersReport, `${exportCustomersReportFor}_customers_report.csv`, "text/plain");
  };

  handleWithPeriod = withPeriod => {
    this.setState({ withPeriod, sinceDate: "", untilDate: "" });
  };

  handleExportCustomersReportFor = exportCustomersReportFor => {
    this.setState({ exportCustomersReportFor, withPeriod: false });
  };

  handleWithNetsuiteFields = withNetSuiteFields => {
    this.setState({ withNetSuiteFields });
  };

  handleAnotherCurrency = data => {
    const anotherCurrencyState = this.state.anotherCurrency;
    let added = data.value.filter(x => !anotherCurrencyState.flatMap(item => item.value).includes(x));
    let removed = anotherCurrencyState.filter(
      x => !data.value.flatMap(item => item).includes(x.value) && x.removed !== true
    );
    if (removed.length) {
      removed[0].removed = true;
      this.removeMinimAnotherCurrency(removed);
      this.setState({ anotherCurrencyState: anotherCurrencyState });
    } else if (added.length) {
      this.setState(prevState => ({
        tenantCurrencies: [...prevState.tenantCurrencies, added[added.length - 1]]
      }));
    }
  };

  separateInvoiceAmountCurrencyNull = data => {
    const separateNull = data.filter(item => item.invoiceMinimAmount === "0.0");
    const separateNotNull = data.filter(item => item.invoiceMinimAmount !== "0.0");
    if (isEmpty(separateNotNull)) {
      const toIndx = [separateNull[0]];
      const removedIndx = separateNull.slice(1);
      this.setState({ separateInvoiceCurrenciesNotNull: toIndx });
      this.setState({ separateInvoiceCurrenciesNull: removedIndx });
    } else {
      this.setState({ separateInvoiceCurrenciesNotNull: separateNotNull });
      this.setState({ separateInvoiceCurrenciesNull: separateNull });
    }
  };

  handleAddRow = () => {
    let item = this.state.separateInvoiceCurrenciesNull[0];
    const item2 = this.state.separateInvoiceCurrenciesNull.slice(1);
    this.setState({ separateInvoiceCurrenciesNull: item2 });
    this.setState({
      separateInvoiceCurrenciesNotNull: [...this.state.separateInvoiceCurrenciesNotNull, item]
    });
  };

  handleRemoveSpecificRow = (idx, id, setFieldValue) => () => {
    const itemRemoved = this.state.separateInvoiceCurrenciesNotNull.map(item => {
      if (item.id === id) {
        return {
          ...item,
          invoiceMinimAmount: null
        };
      }
    });
    const itemRemovedFiltered = itemRemoved.filter(item => item);
    const remove1 = [...this.state.separateInvoiceCurrenciesNotNull];
    const remove2 = [...this.state.newInvoiceCurrencies];
    const remove3 = [...this.state.newInvoiceCurrencies];
    remove1.splice(idx, 1);
    remove2.splice(idx, 1);
    this.setState(state => ({ ...state, separateInvoiceCurrenciesNotNull: remove1 }));
    this.setState({ separateInvoiceCurrenciesNull: [...this.state.separateInvoiceCurrenciesNull, itemRemovedFiltered[0]] });
    const forDb = remove3.map(item => {
      if (item.id !== id) {
        return item;
      } else if (item.id === id) {
        return {
          ...item,
          invoiceMinimAmount: "0.0"
        };
      }
    });
    this.filterInvoiceAmountCurrency(forDb);
    this.setState(state => ({ ...state, newInvoiceCurrencies: forDb }));
    this.updateForm(setFieldValue);
  };

  updateForm = setFieldValue => {
    setFieldValue("invoiceMinAmountAndCurrency", this.handleFlag(true));
  };

  handleInvoiceAmount = (data, key) => {
    const oldTenantCurrenciesAmount = this.state.newInvoiceCurrencies;
    const nextState2 = oldTenantCurrenciesAmount.map(item => {
      if (data.name === "invoiceMinimAmount" && item.id !== key) {
        return item;
      } else if (
        data.name === "invoiceMinimAmount" &&
        item.id === key &&
        data.value !== "" &&
        data.value !== item.invoiceMinimAmount
      ) {
        return {
          ...item,
          invoiceMinimAmount: data.value
        };
      } else if (
        data.name === "invoiceMinimAmount" &&
        item.id === key &&
        data.value === "" &&
        data.value !== item.invoiceMinimAmount
      ) {
        return {
          ...item,
          invoiceMinimAmount: "0.0"
        };
      }
    });

    this.filterInvoiceAmountCurrency(nextState2);
    this.setState(state => ({ ...state, newInvoiceCurrencies: nextState2 }));
  };

  checkModificationInvoiceCurrencies = () => {
    const sameEntries = (x, y) => {
      const xEntries = Object.entries(x);
      if (xEntries.length !== Object.entries(y).length) return false;
      return xEntries.every(([k, v]) => y[k] === v);
    };
    const sameArrays = (arr1, arr2) => arr1.length === arr2.length && arr1.every((x, i) => sameEntries(x, arr2[i]));
    const checkObject = sameArrays(this.state.invoiceAmountCurrency, this.state.newInvoiceCurrencies);
    if (checkObject) {
      this.setState(state => ({ newInvoiceCurrencies: [] }));
    }
  };

  handleFlag = data => {
    if (data.value !== "") {
      this.setState({ isFlag: true });
    }
  };

  filterInvoiceAmountCurrency = invoices => {
    const constInvoices = this.props.tenantCurrencies;
    const invAmountCurr = invoices?.map((item, index) => {
      if (item.invoiceMinimAmount !== constInvoices[index].invoiceMinimAmount) {
        return {
          id: item.id,
          invoiceMinimAmount: item.invoiceMinimAmount
        };
      } else if (constInvoices[index].invoiceMinimAmount !== null && item.invoiceMinimAmount === null) {
        return {
          id: item.id,
          invoiceMinimAmount: item.invoiceMinimAmount
        };
      }
    });
    const cleanUpInvAmountCurrency = invAmountCurr.filter(item => item);
    if (isEmpty(cleanUpInvAmountCurrency)) {
      this.setState({ filteredInvoiceAmountCurrency: invoices });
    } else {
      this.setState({ filteredInvoiceAmountCurrency: cleanUpInvAmountCurrency });
    }
  };

  removeMinimAnotherCurrency = data => {
    const dataNull = this.state.separateInvoiceCurrenciesNull;
    const datNotNull = this.state.separateInvoiceCurrenciesNotNull;
    const remove = this.state.minimAnotherCurrency.filter(item => !item.removed);
    const removeSeparateInvoiceCurrenciesNotNull = datNotNull.filter(item => item.id !== data[0].key);
    const removeseparateInvoiceCurrenciesNull = dataNull.filter(item => item.id !== data[0].key);
    this.setState({ separateInvoiceCurrenciesNotNull: removeSeparateInvoiceCurrenciesNotNull });
    this.setState({ separateInvoiceCurrenciesNull: removeseparateInvoiceCurrenciesNull });
    this.setState({ minimAnotherCurrency: remove });
  };

  findRemovedElement = data => {
    const anotherCurrencyState = this.state.anotherCurrency;
    let removed = anotherCurrencyState?.filter(
      x => !data.value.flatMap(item => item).includes(x.value) && x.removed !== true
    );
    return removed;
  };

  checkCurrencies = data => {
    let removed = this.findRemovedElement(data);
    if (removed.length) {
      const DestroyLink = this.props.tenantCurrencies
        .filter(item => item.currency === removed[0].value)
        .map(item => isEmpty(item.links.destroy));
      return DestroyLink[0];
    }
  };

  handleAutomaticNetsuiteApiImport = automaticNetsuiteApiImport => {
    this.setState({ automaticNetsuiteApiImport });
  };

  handleWithNetsuiteAPI = withNetsuiteApi => {
    this.setState({ withNetsuiteApi });
  };
  render() {
    const {
      exportCustomersReportFor,
      sinceDate,
      untilDate,
      withPeriod,
      withNetSuiteFields,
      emailNotificationValidAPEnabled,
      emailNotificationInvalidAPEnabled,
      automaticNetsuiteApiImport,
      withNetsuiteApi,
      anotherCurrency,
      newInvoiceCurrencies,
      minimAnotherCurrency,
      separateInvoiceCurrenciesNotNull
    } = this.state;
    const {
      inProgress,
      listOfVats,
      availableCurrency,
      type,
      currentTenant,
      icon,
      tenantEdit,
      tenantAdd,
      exportCustomersInProgressForInternalInvoices
    } = this.props;
    const none = "None";
    const percentageOptions = [none, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];
    const paymentEmailsDayOptions = range(1, 29);
    const exportReportFor = [
      { text: "All customers", value: "all", "data-test": "all" },
      { text: "Not marked as exported (new & updated)", value: "not_marked_exported", "data-test": "not_exported" }
    ];
    const boolInitialValues = Object.entries(BOOLEAN_SETTINGS).reduce((result, [field, desc]) => {
      result[field] = get(currentTenant, field, false);
      return result;
    }, {});
    const netsuiteBoolInitialValues = Object.entries(NETSUITE_BOOLEAN_SETTINGS).reduce((result, [field, desc]) => {
      result[field] = get(currentTenant, field, false);
      return result;
    }, {});
    const disableAddRowButton = separateInvoiceCurrenciesNotNull.length === minimAnotherCurrency.length;
    return (
      <Fragment>
        <Modal
          closeIcon
          closeOnDimmerClick
          onClose={this.handleCancel}
          data-test="tenant-modal"
          trigger={
            <AppButton data-test="edit_tenant" onClick={this.handleOpen} className="orange medium" size="large">
              <Icon name={icon} />
              {type}
            </AppButton>
          }
          open={this.state.modalOpen}
          size="small"
        >
          <Header>
            <h1>{type}</h1>
          </Header>
          <Formik
            enableReinitialize
            initialValues={{
              name: get(currentTenant, "name", ""),
              vatCountryCode: get(currentTenant, "vat.id", ""),
              defaultCurrency: get(currentTenant, "defaultCurrency", ""),
              availableCurrencies: get(
                currentTenant,
                "availableCurrencies",
                currentTenant ? anotherCurrency?.map(currency => currency.value) : []
              ),
              vatPercentage: get(currentTenant, "vatPercentage", ""),
              notifyDayValidApCustomers: get(currentTenant, "notifyDayValidApCustomers", ""),
              notifyDayInvalidApCustomers: get(currentTenant, "notifyDayInvalidApCustomers", ""),
              couponsEnabled: get(currentTenant, "couponsEnabled", false),
              callbackUrl: get(currentTenant, "callbackUrl", ""),
              almostOutOfBundlePercentage: get(currentTenant, "almostOutOfBundlePercentage", ""),
              ...boolInitialValues,
              customersReportSubsidiary: get(currentTenant, "customersReportSubsidiary", ""),
              customerInvoicesPrefix: get(currentTenant, "customerInvoicesPrefix", ""),
              customersReportLegacyEntity: get(currentTenant, "customersReportLegacyEntity", ""),
              customersReportTerms: get(currentTenant, "customersReportTerms", ""),
              customersReportSbdm: get(currentTenant, "customersReportSbdm", ""),
              customersReportInvoicingEmail: get(currentTenant, "customersReportInvoicingEmail", ""),
              customersReportPortalName: get(currentTenant, "customersReportPortalName", ""),
              customersReportTaxCode: get(currentTenant, "customersReportTaxCode", ""),
              customersReportEuTaxCode: get(currentTenant, "customersReportEuTaxCode", ""),
              customersReportNonEuTaxCode: get(currentTenant, "customersReportNonEuTaxCode", ""),
              ...netsuiteBoolInitialValues,
              postPaymentsMaxLimit: get(currentTenant, "postPaymentsMaxLimit", null),
              netsuiteApiImport: get(currentTenant, "netsuiteApiImport"),
              automaticNetsuiteApiImport: get(currentTenant, "automaticNetsuiteApiImport"),
              notifyExpiryDays: get(currentTenant, "notifyExpiryDays", 0),
              invoiceMinAmountAndCurrency: false
            }}
            validationSchema={object().shape({
              name: string().required("Required"),
              vatCountryCode: string().required("Required"),
              defaultCurrency: string().required("Required"),
              availableCurrencies: array(),
              postPaymentsMaxLimit: number()
                .positive()
                .nullable()
                .typeError("Number is not valid"),
              customersReportSubsidiary: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customerInvoicesPrefix: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportLegacyEntity: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportTerms: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportSbdm: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportInvoicingEmail: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportTaxCode: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportEuTaxCode: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              customersReportNonEuTaxCode: string()
                .nullable()
                .when(
                  "netsuiteApiImport",
                  {
                    is: true,
                    then: string().required("Field is required!")
                  },
                  {
                    is: false,
                    then: string()
                  }
                ),
              notifyExpiryDays: number()
                .nullable()
                .typeError("Number is not valid")
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              if ("invoiceMinAmountAndCurrency" in values) {
                delete values.invoiceMinAmountAndCurrency;
              }
              if (!isEmpty(values.postPaymentsMaxLimit)) {
                values.postPaymentsMaxLimit = parseFloat(values.postPaymentsMaxLimit);
              }

              if (!isEmpty(values.notifyExpiryDays)) {
                values.notifyExpiryDays = parseInt(values.notifyExpiryDays);
              }

              if (type === tenantAdd) {
                this.tenantCreation(values);
              } else if (type === tenantEdit) {
                this.tenantUpdate(values);
              }
              setSubmitting(false);
              this.handleCancel();
              this.props.dispatch(appLoaded());
            }}
            render={({ values, setFieldValue, isSubmitting, isValid, errors }) => (
              <Form>
                {!inProgress ? (
                  <Modal.Content>
                    <Grid style={{ margin: "30px" }}>
                      <Grid.Row>
                        <Grid.Column>
                          <Checkbox
                            style={{ fontSize: "20px", fontWeight: "bold" }}
                            label="View Netsuite integration settings"
                            toggle
                            data-test="toggle_netsuite"
                            defaultChecked={withNetSuiteFields}
                            onChange={(e, data) => {
                              this.handleWithNetsuiteFields(data.checked);
                            }}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {withNetSuiteFields && type === tenantEdit && (
                        <Grid.Row>
                          <Label>
                            <Icon name="info circle" size="large" />
                            Save this tenant form before generating any report if any of these Netsuite fields changes.
                          </Label>
                        </Grid.Row>
                      )}
                      {withNetSuiteFields && (
                        <>
                          {Object.entries(NETSUITE_NON_BOOLEAN_SETTINGS).map(([field, desc], index) => (
                            <Grid.Row key={index}>
                              <Grid.Column width={7}>
                                <br />
                                {desc}
                              </Grid.Column>
                              <Grid.Column width={9}>
                                <Input
                                  fluid
                                  name={field}
                                  placeholder={desc}
                                  defaultValue={values[field]}
                                  onChange={(e, data) => setFieldValue(field, data.value)}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          ))}
                          {Object.entries(NETSUITE_BOOLEAN_SETTINGS).map(([field, desc], index) => (
                            <Grid.Row key={index}>
                              <Grid.Column width={7}>
                                <br />
                                {desc}
                              </Grid.Column>
                              <Grid.Column width={9}>
                                <Dropdown
                                  name={field}
                                  defaultValue={values[field]}
                                  placeholder={desc}
                                  fluid
                                  selection
                                  options={BOOLEAN_OPTIONS}
                                  onChange={(e, data) => setFieldValue(field, data.value)}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          ))}
                          <Grid.Row>
                            <Grid.Column>
                              <Checkbox
                                className="ui right aligned toggle checkbox"
                                label="Netsuite API Import"
                                toggle
                                data-test="toggle_netsuite_api_import"
                                checked={withNetsuiteApi}
                                onChange={(e, data) => {
                                  this.handleWithNetsuiteAPI(data.checked);
                                  setFieldValue("netsuiteApiImport", data.checked);
                                  if (data.checked === false) {
                                    this.handleAutomaticNetsuiteApiImport(data.checked);
                                    setFieldValue("automaticNetsuiteApiImport", data.checked);
                                  }
                                }}
                              />
                              <Checkbox
                                className="ui right aligned checkbox"
                                label="automatic"
                                data-test="automatic_netsuite_api_import"
                                disabled={!withNetsuiteApi}
                                checked={automaticNetsuiteApiImport}
                                onChange={(e, data) => {
                                  this.handleAutomaticNetsuiteApiImport(data.checked);
                                  setFieldValue("automaticNetsuiteApiImport", data.checked);
                                }}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </>
                      )}
                      {withNetSuiteFields && type === tenantEdit && (
                        <>
                          <Grid.Row>
                            <Label>
                              <Grid.Column>
                                {exportCustomersReportFor && exportCustomersReportFor === "all" && !withPeriod && (
                                  <>
                                    <Icon name="info circle" size="large" />
                                    <b>All customers</b>
                                    <br />
                                    The customers (marked & not marked as exported) that own at least one approved or
                                    delivered invoice. Also, you have the option to export created or updated customers in
                                    some given period.
                                  </>
                                )}
                                {exportCustomersReportFor && exportCustomersReportFor === "all" && withPeriod && (
                                  <>
                                    <Icon name="info circle" size="large" />
                                    <b>All the customers - in the given period / not marked as exported</b>
                                    <br />
                                    The customers (marked & not marked as exported) that have at least one approved or
                                    delivered invoice and were created or updated in the given period / outside of the period
                                    but not marked as exported.
                                  </>
                                )}
                                {exportCustomersReportFor && exportCustomersReportFor === "not_marked_exported" && (
                                  <>
                                    <Icon name="info circle" size="large" />
                                    <b>Not marked as exported</b>
                                    <br />
                                    The customers that have at least one approved or delivered invoice and were never marked
                                    as exported or their exported mark got cleared on a data update since the last export.
                                    <br />
                                  </>
                                )}
                              </Grid.Column>
                            </Label>
                          </Grid.Row>
                          <Grid.Row columns={3}>
                            <Grid.Column width={6} style={{ marginTop: "13px" }}>
                              Export Customers Report CSV for:
                            </Grid.Column>
                            <Grid.Column width={1}>
                              <br />
                              <Icon name="exchange" />
                            </Grid.Column>
                            <Grid.Column width={9}>
                              <Dropdown
                                name={"exportCustomersReport"}
                                data-test="export_customers_report"
                                defaultValue={exportReportFor[0].value}
                                fluid
                                selection
                                options={exportReportFor}
                                onChange={(e, data) => {
                                  this.handleExportCustomersReportFor(data.value);
                                  setFieldValue("exportCustomersReport", data.value);
                                }}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={8}>
                              <Button
                                active
                                color="orange"
                                size="medium"
                                content="Export Report For Internal Invoices"
                                type="button"
                                data-test="export_inv_report"
                                onClick={() => this.generateCustomersReport(INVOICE_SERVICES.INTERNAL_INVOICES)}
                                loading={exportCustomersInProgressForInternalInvoices}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row verticalAlign="middle" data-test="export_period">
                            <Grid.Column width={4}>
                              {exportCustomersReportFor && exportCustomersReportFor === "all" && (
                                <Checkbox
                                  label="Period"
                                  toggle
                                  data-test="toggle_period"
                                  onChange={(e, data) => {
                                    this.handleWithPeriod(data.checked);
                                  }}
                                />
                              )}
                            </Grid.Column>
                            <Grid.Column textAlign="left" width={6}>
                              {exportCustomersReportFor && exportCustomersReportFor === "all" && withPeriod && (
                                <DateInput
                                  dateFormat={DATE_FORMAT_DATE_INPUT}
                                  animation="none"
                                  fluid
                                  clearable
                                  autoComplete="off"
                                  onKeyDown={e => e.preventDefault()}
                                  clearIcon={<Icon name="remove" color="red" />}
                                  name="sinceDate"
                                  placeholder="Customers since"
                                  value={sinceDate || ""}
                                  iconPosition="left"
                                  onChange={(e, data) => {
                                    this.setState({ sinceDate: data.value });
                                  }}
                                />
                              )}
                            </Grid.Column>
                            <Grid.Column textAlign="left" width={6}>
                              {exportCustomersReportFor && exportCustomersReportFor === "all" && withPeriod && (
                                <DateInput
                                  dateFormat={DATE_FORMAT_DATE_INPUT}
                                  animation="none"
                                  fluid
                                  clearable
                                  autoComplete="off"
                                  onKeyDown={e => e.preventDefault()}
                                  clearIcon={<Icon name="remove" color="red" />}
                                  name="untilDate"
                                  placeholder="Customers until"
                                  value={untilDate || ""}
                                  iconPosition="left"
                                  onChange={(e, data) => {
                                    this.setState({ untilDate: data.value });
                                  }}
                                />
                              )}
                            </Grid.Column>
                          </Grid.Row>
                          <Divider />
                        </>
                      )}
                      <Divider />
                      <Grid.Row columns={2}>
                        <Grid.Column width={7}>
                          <br />
                          Name
                        </Grid.Column>
                        <Grid.Column width={9}>
                          <Input
                            name="name"
                            data-test="tenant_name"
                            defaultValue={values.name}
                            fluid
                            onChange={(e, data) => setFieldValue("name", data.value)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={3}>
                        <Grid.Column width={7}>
                          <br />
                          Country VAT %
                        </Grid.Column>
                        <Grid.Column width={9}>
                          <Dropdown
                            name="vatCountryCode"
                            defaultValue={values.vatCountryCode}
                            placeholder="Select country VAT"
                            fluid
                            selection
                            options={listOfVats.map(vat => ({
                              text: vat.country + " - " + vat.percentage + "%",
                              value: vat.countryCode
                            }))}
                            onChange={(e, data) => setFieldValue("vatCountryCode", data.value)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={4}>
                        <Grid.Column width={7}>
                          <br />
                          Default Tenant Currency
                        </Grid.Column>
                        <Grid.Column width={9}>
                          {type === "Add new tenant" ? (
                            <Dropdown
                              name="defaultCurrency"
                              fluid
                              placeholder="EUR"
                              defaultValue={values.siteSettings}
                              selection
                              options={
                                availableCurrency !== null
                                  ? availableCurrency[0].availableCurrencies.map(item => {
                                      return { key: item, value: item, text: item };
                                    })
                                  : []
                              }
                              onChange={(e, data) => setFieldValue("defaultCurrency", data.value)}
                              style={{ minHeight: "auto !important", height: "1em" }}
                            />
                          ) : (
                            <Label>{values.defaultCurrency}</Label>
                          )}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={4}>
                        <Grid.Column width={7}>
                          <br />
                          Another Available Currency
                        </Grid.Column>
                        <Grid.Column width={9}>
                          {type === "Add new tenant" ? (
                            <Dropdown
                              name="availableCurrencies"
                              fluid
                              multiple
                              selection
                              value={values.availableCurrencies}
                              placeholder="EUR"
                              options={
                                availableCurrency !== null
                                  ? availableCurrency[0].availableCurrencies
                                      .map(item => {
                                        return { key: item, value: item, text: item };
                                      })
                                      .filter(item => !values.defaultCurrency.includes(item.value))
                                  : []
                              }
                              onChange={(e, data) => {
                                setFieldValue("availableCurrencies", data.value);
                              }}
                              style={{ minHeight: "auto !important", height: "1em" }}
                            />
                          ) : (
                            <Dropdown
                              name="availableCurrencies"
                              fluid
                              multiple
                              value={values.availableCurrencies}
                              selection
                              options={
                                availableCurrency !== null
                                  ? availableCurrency[0].availableCurrencies.map(item => {
                                      return { key: item, value: item, text: item };
                                    })
                                  : []
                              }
                              onChange={(e, data) => {
                                if (this.findRemovedElement(data)[0]?.value === this.props.currentTenantCurrency) {
                                  NotificationService.addError("You can't delete de default Currency");
                                } else if (!this.checkCurrencies(data)) {
                                  setFieldValue("availableCurrencies", data.value);
                                  this.handleAnotherCurrency(data);
                                } else
                                  NotificationService.addError("On that currencies we have purchase, delete them before");
                              }}
                              style={{ minHeight: "auto !important", height: "1em" }}
                            />
                          )}
                        </Grid.Column>
                      </Grid.Row>
                      {Object.entries(BOOLEAN_SETTINGS).map(([field, desc], index) => (
                        <Grid.Row key={index}>
                          <Grid.Column width={7}>
                            <br />
                            {desc}
                          </Grid.Column>
                          <Grid.Column width={9}>
                            <Dropdown
                              name={field}
                              defaultValue={values[field]}
                              placeholder={desc}
                              fluid
                              selection
                              options={BOOLEAN_OPTIONS}
                              onChange={(e, data) => setFieldValue(field, data.value)}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      ))}

                      <Grid.Row>
                        <Grid.Column width={7}>
                          <br />
                          Send expiry email
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Input
                            error={!isEmpty(errors.notifyExpiryDays)}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            fluid
                            name="notifyExpiryDays"
                            maxLength="2"
                            defaultValue={values.notifyExpiryDays}
                            onChange={(e, data) =>
                              setFieldValue("notifyExpiryDays", isEmpty(data.value) ? null : data.value)
                            }
                          />
                          {errors.notifyExpiryDays && (
                            <Label basic color="red" pointing>
                              {errors.notifyExpiryDays}
                            </Label>
                          )}
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <br />
                          days before expiry
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row columns={6}>
                        <Grid.Column width={6}>Autopay email notifications day of month</Grid.Column>
                        <Grid.Column width={2}>
                          <Checkbox
                            name="notifyDayValidApCustomersCheckBox"
                            data-test="notifyDayValidApCustomersCheckBox"
                            label="With valid payment"
                            defaultChecked={emailNotificationValidAPEnabled}
                            onChange={(e, data) => {
                              setFieldValue("notifyDayValidApCustomers", "none");
                              this.setState({ emailNotificationValidAPEnabled: data.checked });
                            }}
                          />
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Dropdown
                            disabled={!emailNotificationValidAPEnabled}
                            name="notifyDayValidApCustomers"
                            data-test="notifyDayValidApCustomers"
                            value={values.notifyDayValidApCustomers}
                            placeholder={none}
                            fluid
                            selection
                            options={paymentEmailsDayOptions.map(date => ({
                              text: date,
                              value: date
                            }))}
                            onChange={(e, data) => setFieldValue("notifyDayValidApCustomers", data.value)}
                          />
                        </Grid.Column>
                        <Grid.Column width={2}>
                          <Checkbox
                            name="notifyDayInvalidApCustomersCheckBox"
                            data-test="notifyDayInvalidApCustomersCheckBox"
                            label="Without valid payment"
                            defaultChecked={emailNotificationInvalidAPEnabled}
                            onChange={(e, data) => {
                              setFieldValue("notifyDayInvalidApCustomers", "none");
                              this.setState({ emailNotificationInvalidAPEnabled: data.checked });
                            }}
                          />
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Dropdown
                            disabled={!emailNotificationInvalidAPEnabled}
                            name="notifyDayInvalidApCustomers"
                            data-test="notifyDayInvalidApCustomers"
                            value={values.notifyDayInvalidApCustomers}
                            placeholder={none}
                            fluid
                            selection
                            options={paymentEmailsDayOptions.map(date => ({
                              text: date,
                              value: date
                            }))}
                            onChange={(e, data) => setFieldValue("notifyDayInvalidApCustomers", data.value)}
                          />
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={7}>
                          <br />
                          Post payments max limit
                        </Grid.Column>
                        <Grid.Column width={9}>
                          <Input
                            error={!isEmpty(errors.postPaymentsMaxLimit)}
                            fluid
                            name="postPaymentsMaxLimit"
                            defaultValue={values.postPaymentsMaxLimit}
                            onChange={(e, data) =>
                              setFieldValue("postPaymentsMaxLimit", isEmpty(data.value) ? null : data.value)
                            }
                          />
                          {errors.postPaymentsMaxLimit && (
                            <Label basic color="red" pointing>
                              {errors.postPaymentsMaxLimit}
                            </Label>
                          )}
                        </Grid.Column>
                      </Grid.Row>
                      <Divider />
                      <Grid.Row columns={2}>
                        <Grid.Column width={8}>
                          <br />
                          Callback URL (optional)
                        </Grid.Column>
                        <Grid.Column width={8}>
                          <Input
                            fluid
                            name="callbackUrl"
                            defaultValue={values.callbackUrl}
                            onChange={(e, data) => setFieldValue("callbackUrl", data.value)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={2}>
                        <Grid.Column width={8}>
                          <br />
                          Almost out of bundle notification on (optional)
                        </Grid.Column>
                        <Grid.Column width={8}>
                          <Dropdown
                            name="almostOutOfBundlePercentage"
                            defaultValue={values.almostOutOfBundlePercentage}
                            fluid
                            options={percentageOptions.map(percentage =>
                              percentage === none
                                ? {
                                    text: percentage,
                                    value: null
                                  }
                                : {
                                    text: percentage + "%",
                                    value: percentage
                                  }
                            )}
                            selection
                            placeholder={none}
                            onChange={(e, data) => setFieldValue("almostOutOfBundlePercentage", data.value)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={2}>
                        <Grid.Column width={8}>
                          <br />
                          Coupons enabled
                        </Grid.Column>
                        <Checkbox
                          name="couponsEnabledCheckBox"
                          data-test="couponsEnabledCheckBox"
                          checked={values.couponsEnabled}
                          onChange={(e, data) => {
                            setFieldValue("couponsEnabled", data.checked);
                          }}
                        />
                      </Grid.Row>
                      <Divider />
                      <Grid.Row columns={2}>
                        <Grid.Column width={5}> Invoice minimum amount </Grid.Column>
                        <Grid.Column widescreen={8} textAlign="right">
                          <Button
                            icon="checkmark"
                            color="orange"
                            content="Add New Row"
                            data-test="add_new_minim_invoice_amount"
                            type="button"
                            onClick={this.handleAddRow}
                            disabled={disableAddRowButton}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {separateInvoiceCurrenciesNotNull
                        ? separateInvoiceCurrenciesNotNull?.map((item, index) => (
                            <Grid.Row key={item.id}>
                              <Grid.Column widescreen={3} tablet={3}>
                                <Input
                                  onKeyPress={event => {
                                    if (!/[.0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  fluid
                                  name="invoiceMinimAmount"
                                  defaultValue={item.invoiceMinimAmount}
                                  onChange={(e, data) => {
                                    this.handleInvoiceAmount(data, item.id, index, e);
                                    setFieldValue("invoiceMinAmountAndCurrency", this.handleFlag(data));
                                  }}
                                />
                              </Grid.Column>
                              <Grid.Column widescreen={3} tablet={3}>
                                <Dropdown
                                  name={"currency"}
                                  data-test="currency"
                                  selection
                                  defaultValue={item.currency}
                                  options={minimAnotherCurrency}
                                  disabled={true}
                                />
                              </Grid.Column>
                              <Grid.Column widescreen={2} textAlign="right">
                                <Button
                                  size="medium"
                                  style={{ backgroundColor: "#f9fafb" }}
                                  className="text orange"
                                  content="Cancel"
                                  data-test="cancel_tenant"
                                  type="button"
                                  onClick={this.handleRemoveSpecificRow(index, item.id, setFieldValue)}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          ))
                        : []}
                    </Grid>
                  </Modal.Content>
                ) : (
                  <Dimmer active inverted>
                    <Loader size="big" as="h2">
                      Loading...
                    </Loader>
                  </Dimmer>
                )}
                <Modal.Actions
                  style={{
                    backgroundColor: "#f9fafb",
                    textAlign: "right",
                    marginBottom: "10px"
                  }}
                >
                  <Divider />
                  <Button
                    size="medium"
                    style={{ backgroundColor: "#f9fafb" }}
                    className="text orange"
                    content="Cancel"
                    data-test="cancel_tenant"
                    type="button"
                    onClick={this.handleCancel}
                  />
                  {type === "Add new tenant" ? (
                    <Button
                      icon="checkmark"
                      color="orange"
                      content="Create tenant"
                      data-test="create_tenant"
                      type="submit"
                      disabled={isSubmitting || !isValid}
                    />
                  ) : (
                    <Button
                      classame={"is-valid" + isValid}
                      icon="checkmark"
                      color="orange"
                      content="Save"
                      data-test="save_tenant"
                      type="submit"
                      disabled={isSubmitting || !isValid}
                    />
                  )}
                </Modal.Actions>
              </Form>
            )}
          />
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  currentTenantCurrency: get(state, "common.currentTenant.defaultCurrency"),
  availableCurrency: build(state.siteSettings, "list", null, {
    ignoreLinks: true
  }),
  listOfVats: build(state.vatsReducer, "list", null, {
    ignoreLinks: true
  }),
  tenantCurrencies: build(state.tenantCurrenciesReducer, "list", null, {
    ignoreLinks: true
  }),
  inProgress: state.vatsReducer.inProgress,
  exportCustomersInProgressForInternalInvoices: state.exportCustomersReportReducer.internalInvoicesInProgress,
  customersReport: state.exportCustomersReportReducer.customersReport,
  errors: state.exportCustomersReportReducer.errors,
  products: build(get(state, "products.productOptions", {}) || {}, "products", null, {
    ignoreLinks: true
  }),
  productBundles: build(get(state, "products", {}) || {}, "productBundles", null, {
    ignoreLinks: true
  }),
  productLicenseBundles: build(get(state, "products", {}) || {}, "productLicenseBundles", null, {
    ignoreLinks: true
  }),
  bundles: build(get(state, "bundles.bundles", {}) || {}, "bundles", null, {
    ignoreLinks: true
  }),
  licenseBundles: build(get(state, "licenseBundles.licenseBundles", {}) || {}, "licenseBundles", null, {
    ignoreLinks: true
  }),
  withNetsuiteApi: get(state, "common.currentTenant.netsuiteApiImport", {}),
  withAutomaticNetsuiteApiImport: get(state, "common.currentTenant.automaticNetsuiteApiImport", {})
});

export default connect(mapStateToProps)(TenantModal);
